<template>
	<main class="view-teacher">
		<div style="text-align: center;">
			<el-avatar :size="120" :src="model.avatar" />
			<br /><br />
			<span class="realname">{{ model.account.realname }}</span>
		</div>

		<div style="margin-top: 20px;">
			<el-row :gutter="20">
				<el-col :span="3" class="field_label">登录名</el-col>
				<el-col :span="20" class="field_val">{{ model.account.login_name }}</el-col>
			</el-row>

			<el-row :gutter="20">
				<el-col :span="3" class="field_label">手机号</el-col>
				<el-col :span="20" class="field_val">{{ model.account.mobile }}</el-col>
			</el-row>

			<!-- <el-row :gutter="20">
        <el-col :span="3" class="field_label">昵称</el-col>
        <el-col :span="20" class="field_val">{{
          model.account.nickname
        }}</el-col>
      </el-row> -->
		</div>
	</main>
</template>
<script>
export default {
	data() {
		return {
			model: {
				account: {}
			}
		}
	},
	async created() {
		this.model = await this.$api.teacher.show(this.$route.params.id)
		this.$emit('breadcrumbChange', [
			{
				name: '详情',
				to: null
			}
		])
	},
	methods: {}
}
</script>

<style lang="scss">
.view-teacher {
	padding: 30px;

	.field_label {
		text-align: right;
		font-size: 16px;
	}

	.field_val {
		font-weight: lighter;
		font-size: 16px;
	}

	.realname {
		font-size: 24px;
		margin-top: 1em;
	}
}
</style>
